export default __webpack_public_path__ + "static/media/img6.104ea977.jpg";